import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Email from '../../shared/Email';
import NextButton from '../../shared/NextButton';
import { FormContext } from '../../Context';

import './Step1.scss';

function Step1({ callback, disabled }) {
    const [t] = useTranslation();
    const emailRef = useRef();

    const [validate, setValidate] = useState(false);
    const [validated, setValidated] = useState(false);
    const [blank, setBlank] = useState(true);
    const [doingAjax, setDoingAjax] = useState(disabled);

    const handleSubmit = (e) => {
        e.preventDefault();
        setDoingAjax(true);
        setValidate(true);
        setValidated(false);
    };

    useEffect(() => {
        if (validated) {
            if (emailRef.current.attributes['aria-invalid'].value !== 'true') callback(emailRef.current?.value);

            setDoingAjax(false);
            setValidate(false);
            setValidated(false);
        }
    }, [validated, callback]);

    return (
        <div
            id="form-forgot-password-init"
            role="main"
        >
            <FormContext.Provider value={{ triggerValidation: validate, validationFinished: setValidated }}>
                <h2>{t('Authentication.ForgotPasswordPage.Title')}</h2>
                <p>{t('Authentication.ForgotPasswordPage.Instructions')}</p>
                <Email
                    ref={emailRef}
                    labelText={t('Authentication.ForgotPasswordPage.Email')}
                    placeholder={t('Authentication.ForgotPasswordPage.EnterEmail')}
                    disabled={disabled}
                    autofocus={true}
                    onChange={(e) => setBlank(e.length === 0)}
                />
                <NextButton
                    action={handleSubmit}
                    disabled={doingAjax || blank}
                >
                    {t('Authentication.ForgotPasswordPage.SendInstructions')}
                </NextButton>
                <Link
                    to="/signin"
                    id="cancel"
                >
                    {t('Authentication.ForgotPasswordPage.Return')}
                </Link>
            </FormContext.Provider>
        </div>
    );
}

export default Step1;
